module.exports = __webpack_public_path__ + "static/media/image_1.8decd8a4.png";